const Messenger = require("./lib/client.js").default

module.exports = Messenger
